<template>
	<div class="popup save_popup upgrade-popup sign-in">

		<a class="close_popup_btn" v-on:click="changePopup('signIn', false)">
			<span class="inch-icon inch-close-icon"></span>
		</a>
		<h2 class="title sm">{{ isForgotPopup ? 'Forgot password' : 'Sign in' }}</h2>

		<div class="is_offline" v-if="isOffline">
			<Offline></Offline>
		</div>     
		<div class="social-login">
			<button type="submit" @click="socialAuthenticate('google')" class="gsi-material-button">
				<div class="gsi-material-button-state"></div>
				<div class="gsi-material-button-content-wrapper">
					<div class="gsi-material-button-icon">
						<svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"
							xmlns:xlink="http://www.w3.org/1999/xlink" style="display: block;">
							<path fill="#EA4335"
								d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z">
							</path>
							<path fill="#4285F4"
								d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z">
							</path>
							<path fill="#FBBC05"
								d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z">
							</path>
							<path fill="#34A853"
								d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z">
							</path>
							<path fill="none" d="M0 0h48v48H0z"></path>
						</svg>
					</div>
					<span class="gsi-material-button-contents">Continue with Google</span>
				</div>
			</button>
		</div>

		<div style="display: flex; align-items: center; margin: 1.5rem 0;">
			<div style="flex: 1; height: 1px; background-color: #ccc;"></div>
			<span style="margin: 0 1rem; color: #777; font-weight: 500; font-size: 14px;">
				OR
			</span>
			<div style="flex: 1; height: 1px; background-color: #ccc;"></div>
		</div>
		
		<form id="login_form" v-on:submit.prevent="onSubmit" v-if="isOnline">
			<div class="form_loading" v-if="isLoading"></div>

			<div class="form-group">
				<div class="label">{{ isForgotPopup ? 'EMAIL': 'USERNAME / EMAIL' }}</div>
				<input type="email" ref="xemail" name="email" class="form-control xemail" :value="email" />
			</div>
			<div class="form-group" v-if="!isForgotPopup">
				<div class="label">PASSWORD</div>
				<input type="password" ref="xpassword" name="password" class="form-control" :value="password" />
			</div>
			<div class="form_errors" v-if="formErrors">
				<ul id="example-1">
					<li v-for="item in formErrors">{{ item[0] }}</li>
				</ul>
			</div>
			<p style="color: green; text-align: left;" v-if="formMessage">
				{{ formMessage }}
			</p>
			
			<div class="btn-wrap" style="display: flex;align-items: center;justify-content: space-between;">
				<input type="submit" class="btn-orange" :value="isForgotPopup ? 'Send request': 'Sign in'" style="padding: 15px 40px;"/>
				<label class="checkbox" v-if="!isForgotPopup" style="font-size: 13px;margin: 0;">
					<input type="checkbox" checked="checked" name="remember" id="remember" ref="remember" />
					<span class="check"></span>
					Remember Me
				</label>
			</div>
			
			<div class="bottom-info" style="margin-top: 32px;">
				<a @click="forgotPassword(true)" v-if="!isForgotPopup" style="margin: 0;">Forgot password?</a>
				<a @click="forgotPassword(false)" v-if="isForgotPopup" style="margin: 0;">Sign in</a>
			</div>
		</form>
	</div>
</template>


<script>
import Acc from "@/libs/acc.js";
import Offline from "@/components/Offline.vue";
import { initializeMixpanel, trackMxEvent } from '@/libs/mixpanel.js';
import { Providers } from 'universal-social-auth'

//client@mail.com
//123123123

export default {
	name: "SignIn",
	data() {
		return {
			isLoading: false,
			acc: new Acc(),
		formErrors: null,
		formMessage: null,
		isForgotPopup: false,
		email: "",
		password: ""
		};
	},
	components:{
		Offline
	},
	methods: {
		socialAuthenticate(provider) {
			const ProData = Providers[provider]
			this.$Oauth.authenticate(provider, ProData).then(async (response) => {
				const rsp = response
				if (rsp.code) {
					try {
						const pdata = { code: rsp.code }
						const result = await this.acc.socialLogin(provider, pdata);
						if (result) {
							this.$store.dispatch('refreshUser');
							if (result?.data?.user?.email) {
								try {
									initializeMixpanel(result?.data?.user);
									trackMxEvent('Sign In', {
									method: 'google',
									popup_type: 'signin',
									});
								} catch (error) {
									// 
								}
							}
							this.changePopup('signIn', false)
						}
					} catch (error) {
						//
					}
				}
			}).catch((err) => {
				console.log(err)
			})
		},
		forgotPassword(status) {
			this.isForgotPopup = status;
		},
		async onSubmit(ev) {
		this.isLoading = true;
		if(this.isForgotPopup) {
			await this.acc.resetPassword(this.$refs.xemail.value);
			this.formMessage = "A password reset link has been sent to your email. Please check your inbox.";
			this.isLoading = false;
			return;
		}
			this.formErrors = null;
			var resp = await this.acc.login({
				email: this.$refs.xemail.value,
				password: this.$refs.xpassword.value,
				remember: this.$refs.remember.checked
			});

			this.formErrors = resp.errors;
			this.isLoading = false;

			if (resp.success) {
				
				try {
					initializeMixpanel(this.USER);
					trackMxEvent('Sign In', {
						method: 'email',
						popup_type: 'signin',
					});
				} catch (error) {
					// 
				}
				
				
				if(this.$route.query.redirect) {
					this.$router.push(this.$route.query.redirect);
				}

				this.$store.state.USER = resp.data.user;
				if(resp.data.user) {
					$('meta[name=uniq_id]').attr('content', resp.data.user.id);
				}
				
				this.changePopup("signIn", false);
			}
		},
		changePopup(property, value) {
			this.$store.dispatch("popupsToggle", { property, value });
		}
	}
};
</script>

<style>
.form_loading {
	position: absolute;
	left: 0;
	top: 0;
	width: 100%;
	height: 100%;
	background: #8080809c;
	z-index: 10000;
}

.btn-orange {
	border: none;
}
.form_errors {
	/*color: red;*/
	/*font-weight: bold;*/
	text-align: left;
	font: normal normal normal 14px/20px Soleil;
	color: #FF5353;
  letter-spacing: -0.28px;
}
.popup.save_popup.upgrade-popup.sign-in .title{
	font-size: 26px;
}

.form-group .label {
	font-size: 13px !important;
}


.popup.save_popup.upgrade-popup .btn-wrap .checkbox {
    text-transform: uppercase;
    font-size: 14px;
    padding-left: 30px;
}

.popup.save_popup.upgrade-popup .btn-wrap .check {
    border-color: #E5E5E5;
}

.popup.save_popup.upgrade-popup .btn-wrap input:checked~.check {
    background-color: #FA6400;
    border-color: #FA6400;
}

.popup.save_popup.upgrade-popup .btn-wrap input:checked~.check::after {
    border-color: #fff;
}
.popup.save_popup.upgrade-popup .btn-wrap a.change-sub-card {
	margin-bottom: 12px;
	display: inline-block;
	text-transform: uppercase;
	text-align: center;
	font: normal normal normal 14px/18px Soleil;
	letter-spacing: -0.28px;
	color: #FFFFFF;
}

.popup.save_popup.upgrade-popup .btn-wrap a.update-card {
	margin-bottom: 12px;
	display: inline-block;
	text-transform: uppercase;
	text-align: center;
	font: normal normal normal 14px/18px Soleil;
	letter-spacing: -0.28px;
	color: #FFFFFF;
}

.popup.save_popup.upgrade-popup .btn-wrap a {
    margin-bottom: 12px;
    display: inline-block;
    text-transform: uppercase;
    /*color: #1d1d1d;*/
	font: normal normal normal 14px/18px Soleil;
	letter-spacing: -0.28px;
	color: #FFFFFF;
}

</style>
